export default __webpack_public_path__ + "static/media/3d-gis-launch-kit.3fda7028.svg";